/**
 * Gantt section band — a full-width row group with an alternating tint and the
 * section name on the left (in the label gutter). Renders behind the task bars.
 */

import { memo } from 'react'
import { NodeProps } from '@xyflow/react'
import type { GanttSection } from '../../types/schema'
import { GANTT_LABEL_W } from '../../utils/ganttLayout'

interface SectionData {
  label: string
  ganttSection?: GanttSection
}

function GanttSectionNode({ data, width, height }: NodeProps) {
  const nodeData = data as unknown as SectionData
  const s = nodeData.ganttSection
  const name = s?.name ?? nodeData.label ?? ''
  const tint = (s?.index ?? 0) % 2 === 0 ? 'rgba(148,163,184,0.06)' : 'rgba(148,163,184,0.13)'
  return (
    <div
      style={{
        width: typeof width === 'number' ? width : 400,
        height: typeof height === 'number' ? height : 34,
        background: tint,
        borderTop: '1px solid #e2e8f0',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        pointerEvents: 'none',
        fontFamily: 'Inter, system-ui, sans-serif',
      }}
    >
      <div style={{ width: GANTT_LABEL_W, padding: '0 12px', fontSize: 12, fontWeight: 700, color: '#475569', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {name}
      </div>
    </div>
  )
}

export default memo(GanttSectionNode)
